// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"24":"c6a02d5268e9fd01eadf","816":"7f3de87123c85cdaf37b"}[chunkId] + ".js";
};